import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { ConfigurationsService } from '@icc/configurator/shared';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared';
import { ICC_PAGE_DATA, PageComponent } from '@icc/configurator/shared';
import { iccListItem } from '@icc/configurator/ui';
import { IccAccessoryAccessory, IccAccessoryColor } from '@icc/construction-elements/types';
import { ColorDto as IccColor } from '@icc/construction-elements/types';
import { SharedFacade } from '@icc/configurator/shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ColorMappingService } from '@icc/construction-elements/configurator';
import { KeysService } from '../cylinders-page/keys.service';
import { NumericDictionary } from 'lodash';

@Component({
    selector: 'icc-recessed-pull-options-page',
    templateUrl: './recessed-pull-options-page.component.html',
    styleUrls: ['./recessed-pull-options-page.component.scss'],
    standalone: false
})
export class RecessedPullOptionsPageComponent extends PageComponent implements OnInit {
    public title: string = _('DOOR|Opcje osprzętu');
    selectedType: IccAccessoryAccessory | null = null;
    colors: {colorSource: string, colors: iccListItem[]}[] = [];
    selColor: {colorSource: string, color: IccAccessoryColor | IccColor, isDefault: boolean, price: number, list_price: number} | null = null;
    selectColorId = '0';
    defaultColor = false;
    hiddenPrice = false;

    selectedTypeImg = '';
    currency = null;

    constructor(
        @Inject(APP_CONFIG) public config: AppConfigFactory,
        private sharedFacade: SharedFacade,
        @Inject(ICC_PAGE_DATA)
        private pageData: {
            title: string;
            selectedType: IccAccessoryAccessory;
            recessedPullColors?: {colorSource: string, colors: IccAccessoryColor[] | IccColor[], price: number, list_price: number}[];
            selColor: {colorSource: string, color: IccAccessoryColor | IccColor, isDefault: boolean, price: number, list_price: number};
            colorIdToMapping: number | null;
        }
    ) {
        super();
        if(pageData.title) {
            this.title = pageData.title;
        }
    }

    ngOnInit() {
        this.hiddenPrice = this.config().preset === 'b2c' && this.config().hidePricesInB2cConfigurator;

        this.sharedFacade.currency$.subscribe((currency) => {
            this.currency = currency;
        });
        this.selectedType = this.pageData.selectedType;
        this.selColor = this.pageData.selColor;
        this.defaultColor = Boolean(this.pageData.selColor && this.pageData.selColor.isDefault);
        this.colors = !this.pageData.recessedPullColors ? [] : this.pageData.recessedPullColors.map(colors => ({
            colorSource: colors.colorSource,
            colors: (colors.colors as any[]).map(color => ({
                id: color.id,
                title: color.name,
                color: '#' + color.color,
                imageUrl: colors.colorSource === 'accessory_color' ?  '/files/windowhandlescolor/' + color.color_img : '/files/color/' + color.colorImg,
            }))
        }))
        this.setDefaultColors();
        this.selectColorId = String(this.selColor.color.id);
        this.selectedTypeImg = '/files/windowaccessory/' + this.selectedType.img;
    }

    private setDefaultColors() {
        if (this.selectedType) {
            if (!this.selColor) {
               this.selColor = {
                colorSource: this.colors[0].colorSource,
                color: this.pageData.recessedPullColors[0].colors[0],
                isDefault: true,
                price: this.pageData.recessedPullColors[0].price,
                list_price: this.pageData.recessedPullColors[0].list_price,

            };
               this.defaultColor = true;
            }
        }
    }

    selectColor(colorItem: IccAccessoryColor| IccColor, colorSource) {
        const type = this.pageData.selectedType;
        const colors = this.pageData.recessedPullColors.find(recessedPullColor => recessedPullColor.colorSource === colorSource && recessedPullColor.colors.some(c => Number(c.id) === Number(colorItem.id)));
        const color = (colors.colors as any[]).find(c => Number(c.id) === Number(colorItem.id))
        if (type && color) {
            this.selColor = {colorSource, color, isDefault: false, price: colors.price, list_price: colors.list_price};
            this.defaultColor = false;
        }
        this.selectColorId = String(this.selColor.color.id);
    }

    save() {
        this.sharedFacade.closePage({
            type: this.pageData.selectedType,
            color: this.selColor,
            defaultColor: this.defaultColor,
        });
    }

    getColorName() {
        return this.selColor.color.name;
    }
}
